// ============================================================================
// Checkbox.jsx — Corelia UI v1.2
// Case à cocher standardisée, harmonisée avec Radio, Switch, TextField
// ============================================================================
import theme from "../../../styles/theme";

const Checkbox = ({
  label = "Option",
  checked = false,
  onChange,
  disabled = false,
  style = {},
  inputStyle = {},
}) => {
  return (
    <label
      style={{
        display: "flex",
        flexDirection: "row",                        // label à gauche, checkbox à droite
        alignItems: "center",
        gap: theme.spacing.xs,
        cursor: disabled ? "not-allowed" : "pointer",
        fontFamily: theme.form.field.fontFamily,
        fontSize: theme.form.field.fontSize,
        fontWeight: theme.form.field.fontWeight,
        color: disabled ? theme.colors.states.muted : theme.form.field.color,
        opacity: disabled ? 0.6 : 1,
        transition: "color 0.2s ease",
        lineHeight: 1.3,
        ...style,
      }}
    >
      {/* Label texte */}
      <span style={{ flexShrink: 0 }}>{label}</span>

      {/* Case à cocher */}
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => !disabled && onChange(e.target.checked)}
        style={{
          accentColor: disabled
            ? theme.colors.states.disabled
            : theme.colors.states.enabled,
          cursor: disabled ? "not-allowed" : "pointer",
          width: 14,
          height: 14,
          flexShrink: 0,                 // évite la déformation en layout flex
          borderRadius: theme.borders.radius.sm,
          transition: "all 0.2s ease",
          ...inputStyle,
        }}
      />
    </label>
  );
};

export default Checkbox;
